import { Grid2 } from '@aibees/shared/components';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Grid2)``;

export const Info = styled(Grid2)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: ${(p) => p.theme.spacing(0.5)};
`;
